import { Cloneable } from './cloneable';
import { Serializable } from './serializable';

export interface InventoryHistoryJSON {
  ID: number;
  saleID: number;
  productID: number;
  actionID: number;
  action: string;
  inventoryCount: number;
  dateTime: string;
  productName: string;
  adjustment: number;
}


export interface InventoryHistorySerialized extends InventoryHistoryJSON {
  ID: number;
  saleID: number;
  productID: number;
  actionID: number;
  action: string;
  inventoryCount: number;
  dateTime: string;
  productName: string;
  adjustment: number;
};

export class InventoryHistory implements Cloneable<InventoryHistory, InventoryHistoryJSON>, Serializable<InventoryHistorySerialized> {

  public readonly ID: number;

  public readonly saleID: number;

  public readonly productID: number;

  public readonly actionID: number;

  public readonly action: string;

  public readonly inventoryCount: number;

  public readonly datetime: string;

  public readonly productName: string;

  public readonly adjustment: number;

  constructor(options: InventoryHistoryJSON) {
    this.ID = options.ID;
    this.action = options.action;
    this.saleID = options.saleID;
    this.productID = options.productID;
    this.actionID = options.actionID;
    this.action = options.action;
    this.inventoryCount = options.inventoryCount;
    this.datetime = options.dateTime;
    this.productName = options.productName;
    this.adjustment = options.adjustment;
  }

  public getID(): number {
    return this.ID;
  }

  public getSaleID(): number {
    return this.saleID;
  }

  public getProductID(): number {
    return this.productID;
  }

  public getActionID(): number {
    return this.actionID;
  }

  public getAction(): string {
    return this.action;
  }

  public getInventoryCount(): number {
    return this.inventoryCount;
  }

  public getDatetime(): string {
    return this.datetime;
  }

  public getProductName(): string {
    return this.productName;
  }

  public getAdjustment(): number {
    return this.adjustment;
  }

  public setID(value: number): InventoryHistory {
    const data: InventoryHistoryJSON = this.toJSON();
    data.ID = value;
    return new InventoryHistory(data);
  }

  public setSaleID(value: number): InventoryHistory {
    const data: InventoryHistoryJSON = this.toJSON();
    data.saleID = value;
    return new InventoryHistory(data);
  }

  public setProductID(value: number): InventoryHistory {
    const data: InventoryHistoryJSON = this.toJSON();
    data.productID = value;
    return new InventoryHistory(data);
  }

  public setActionID(value: number): InventoryHistory {
    const data: InventoryHistoryJSON = this.toJSON();
    data.actionID = value;
    return new InventoryHistory(data);
  }

  public setAction(value: string): InventoryHistory {
    const data: InventoryHistoryJSON = this.toJSON();
    data.action = value;
    return new InventoryHistory(data);
  }

  public setInventoryCount(value: number): InventoryHistory {
    const data: InventoryHistoryJSON = this.toJSON();
    data.inventoryCount = value;
    return new InventoryHistory(data);
  }

  public setDatetime(value: string): InventoryHistory {
    const data: InventoryHistoryJSON = this.toJSON();
    data.dateTime = value;
    return new InventoryHistory(data);
  }

  public setProductName(value: string): InventoryHistory {
    const data: InventoryHistoryJSON = this.toJSON();
    data.productName = value;
    return new InventoryHistory(data);
  }

  public setAdjustment(value: number): InventoryHistory {
    const data: InventoryHistoryJSON = this.toJSON();
    data.adjustment = value;
    return new InventoryHistory(data);
  }

  public static parseInventoryHistoryData(params: Object): InventoryHistory {
    return new InventoryHistory({
      ID: params['ID'],
      saleID: params['saleID'],
      productID: params['productID'],
      actionID: params['actionID'],
      action: params['action'],
      inventoryCount: params['inventoryCount'],
      dateTime: params['dateTime'],
      productName: params['productName'],
      adjustment: params['adjustment']
    });
  }

  public toJSON(): InventoryHistoryJSON {
    return {
      ID: this.ID,
      saleID: this.saleID,
      productID: this.productID,
      actionID: this.actionID,
      action: this.action,
      inventoryCount: this.inventoryCount,
      dateTime: this.datetime,
      productName: this.productName,
      adjustment: this.adjustment
    };
  }

  public clone(): InventoryHistory {
    return new InventoryHistory(this.toJSON());
  }

  public serialize(): InventoryHistorySerialized {
    return {
      ID: this.ID,
      saleID: this.saleID,
      productID: Number(this.productID),
      actionID: this.actionID,
      action: this.action,
      inventoryCount: this.inventoryCount,
      dateTime: this.datetime,
      productName: this.productName,
      adjustment: this.adjustment
    };
  }

}